<template>
    <div class="sso">
        <OtButton
            v-if="showBeatport"
            class="is-fullwidth"
            @click="useBeatport()"
        >
            {{ $t('login.login.sso.beatport.submit.text') }}
            <i class="oti oti-arrow-right ot-button-icon--right"/>
        </OtButton>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import OtButton from './OtButton.vue';
import {
    combineSingleSignOnActions,
    getSingleSignOnActionOverrides,
    SINGLE_SIGN_ON_ACTION, type SingleSignOnAction,
    type SingleSignOnActionOverrides,
} from '../services/util/signInAction';

@Component({ components: { OtButton } })
export default class SingleSignOn extends Vue {

    ssoActionOverrides: SingleSignOnActionOverrides = {};

    created() {
        // DD-4E8B - Sign in overrides can only be applied on sso providers which are configured for a whitelabel.
        // If an override is wanted for a default action, the provider must be explicitly configured first.
        this.ssoActionOverrides = getSingleSignOnActionOverrides();
    }

    get showBeatport(): boolean {
        // DD-4E87 - The beatport sso button is hidden by default, unless specifically shown.
        const combined = combineSingleSignOnActions(
            this.$whitelabel.login.sso?.beatport?.action ?? '',
            this.ssoActionOverrides['login_sso[beatport]'],
        );

        if (!combined) {
            // When combined is falsey, the button should only be shown if the config action is set to auto-redirect.
            // This allows the no-auto-redirect case to disable auto-redirecting without hiding the button altogether.
            return this.$whitelabel.login.sso?.beatport?.action === SINGLE_SIGN_ON_ACTION.AUTO_REDIRECT;
        }

        const showActions: SingleSignOnAction[] = [
            SINGLE_SIGN_ON_ACTION.AUTO_REDIRECT,
            SINGLE_SIGN_ON_ACTION.SHOW,
        ];

        return showActions.includes(combined);
    }

    useBeatport(): void {
        this.$emit('use-sso', { provider: 'beatport' });
    }

}
</script>

<style lang="scss" scoped>
.sso {
    gap: var(--ot-spacing-default);
}
</style>
